import { Html } from '@react-three/drei'
import type { HtmlProps } from '@react-three/drei/web/Html'
import type { FunctionComponent } from 'react'

import styles from './mute-button.module.scss'

export const MuteButton: FunctionComponent<MuteButtonProps> = ({
    muted,
    onClick,
    ...rest
}) => {
    return (
        <Html center {...rest}>
            <img
                onClick={onClick}
                className={styles['mute-image']}
                width='40'
                height='40'
                src={muted ? 'icons/mute.svg' : 'icons/unmute.svg'}
            />
        </Html>
    )
}

interface MuteButtonProps extends HtmlProps {
    muted: boolean
    onClick: () => void
}
